module.exports = __webpack_public_path__ + "img/culture3Hover.0c4841de.jpg";